module.exports = __webpack_public_path__ + "static/media/boat-img-20.df15a020.jpg";